/* Layout */
import Layout from '@/views/Workbench/layout/Layout'

export default {
  path: '/workbench',
  component: Layout,
  redirect: 'workbench/approve',
  children: [
    { 
      path: 'approve', 
      component: () => import('@/views/Workbench/approve/index.vue'),
      // redirect: 'approve/upcoming',
      // children: [
      //   {
      //     name: 'upcomings',
      //     path: 'upcoming', 
      //     component: () => import('@/views/Workbench/approve/upcoming.vue'),
      //   },
      //   {
      //     name: 'dones',
      //     path: 'done', 
      //     component: () => import('@/views/Workbench/approve/done.vue'),
      //   },
      //   {
      //     name: 'mines',
      //     path: 'mine', 
      //     component: () => import('@/views/Workbench/approve/mine.vue'),
      //   }
      // ]
    }
  ]
}
